import { TimePeriod } from '@/modules/fund/types';
import { AllAnalysisData } from '@/modules/costAnalysis/types';
import { PensionScheme } from '../types';

export interface IAssetOwnerState {
  rootInvestmentId: string | null;
  entityRootInvestmentIds: string[];
  entityRootInvestments: PensionScheme[];
  selectedTimePeriod: TimePeriod;
  costAnalysisDetails: AllAnalysisData;
}

export const AssetOwnerState: IAssetOwnerState = {
  rootInvestmentId: null,
  entityRootInvestmentIds: [],
  entityRootInvestments: [],
  selectedTimePeriod: {} as TimePeriod,
  costAnalysisDetails: {} as AllAnalysisData
};
